import React from 'react';
import Slider from 'react-slick';

import Slide_1 from '../../../../assets/images/Слайдер/Slider_1.jpg';
import Slide_2 from '../../../../assets/images/Слайдер/Slider_2.jpeg';
import Slide_3 from '../../../../assets/images/Слайдер/Slider_3.jpeg';

const SliderComponent = () => {

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500
  }

  return (
    <div 
      className="slider" 
      style={{
        overflow: 'hidden',
        marginTop: '0'
      }}>
      <Slider {...settings}>
        <div>
            <div 
              className="slider-item"
              style={{
                background: `url(${Slide_1}) no-repeat`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                height: '500px'
              }}>

            </div>
        </div>
        <div>
            <div 
              className="slider-item"
              style={{
                background: `url(${Slide_2}) no-repeat`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '500px'
              }}>

            </div>
        </div>
        <div>
            <div 
              className="slider-item"
              style={{
                background: `url(${Slide_3}) no-repeat`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '500px'
              }}>

            </div>
        </div>
      </Slider>
    </div>
  );
};

export default SliderComponent;